import defaultTheme from './default';
import customTheme from './custom';

const themes = {
  defaultTheme,
  customTheme,
};

export const themeConfig = {
  topbar: 'themeCustom',
  sidebar: 'themeCustom',
  layout: 'defaultTheme',
  theme: 'defaultTheme',
};
export default themes;
